// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"ad6cf491","292":"6a84cb92","322":"3dc4a380","491":"c6bede65","508":"4bf3f08b","905":"38472766","963":"5bbf0b9f"}[chunkId] + ".chunk.js";
};